import React, { useEffect, useState } from 'react';
import { StyledContainer } from './Container.styled';
import { StyledSlider } from './Slider.styled';
import { StyledTextContainer } from './TextContainer.styled';

export interface ICameraSettingsItemSliderProps {
	min: number;
	max: number;
	step?: number;
	defaultValue?: number;
	children?: React.ReactNode;
	onChange?: (newValue: number) => void;
}

const CameraSettingsItemSlider: React.FC<ICameraSettingsItemSliderProps> = ({
	min,
	max,
	step,
	defaultValue,
	children,
	onChange,
}) => {
	const [value, setValue] = useState<number>(defaultValue ?? 0);

	useEffect(() => {
		onChange?.(value);
	}, [value, onChange]);

	return (
		<StyledContainer>
			<StyledTextContainer>
				<span>{children}</span>
				<span>{value}</span>
			</StyledTextContainer>
			<StyledSlider
				min={min}
				max={max}
				step={step ?? 1}
				value={value}
				onChange={(e) => setValue(parseInt(e.currentTarget.value))}
			/>
		</StyledContainer>
	);
};

export { CameraSettingsItemSlider };
